export default "__VITE_ASSET__BC8q7uA9__"